module.exports = __webpack_public_path__ + "static/before2-2e7c2dcf982f843696c4575e56866f3d.jpg";